module.exports = __webpack_public_path__ + "img/OTG_Logo_Landscape.87f26fef.png";